// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3yEhu","loaderOuter":"PageOverlayLoader_loaderOuter__BwBZU"};